import { render, staticRenderFns } from "./CreateStoryView.vue?vue&type=template&id=1fc518bc&scoped=true&"
import script from "./CreateStoryView.vue?vue&type=script&lang=ts&"
export * from "./CreateStoryView.vue?vue&type=script&lang=ts&"
import style0 from "./CreateStoryView.vue?vue&type=style&index=0&id=1fc518bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc518bc",
  null
  
)

export default component.exports